import { grantXp } from '../progression';
import type { Pickup, Player } from '../types';
import { entitiesOfKind, getPlayer, type World } from '../world';

/** Crédite un pickup au joueur (kamas ou xp, avec montées de niveau), émet les événements et supprime l'entité. */
export function collectPickup(world: World, p: Player, pk: Pickup): void {
  world.entities.delete(pk.id);
  let amount = pk.amount;
  if (pk.pickupType === 'kamas') {
    if (world.meta.kamasPct !== 0) amount = Math.round(amount * (1 + world.meta.kamasPct / 100));
    p.kamas += amount;
  } else grantXp(world, p, amount);
  world.events.push({ type: 'pickup', pickupType: pk.pickupType, amount });
}

export function pickupSystem(world: World): void {
  const p = getPlayer(world);
  if (!p || !p.alive) return;
  for (const pk of entitiesOfKind<Pickup>(world, 'pickup')) {
    if (Math.hypot(pk.pos.x - p.pos.x, pk.pos.y - p.pos.y) > p.radius + 24 + world.meta.pickupRange) continue;
    collectPickup(world, p, pk);
  }
}

/** À la fin de la salle, ramasse automatiquement tous les pickups restants (ordre d'insertion). */
export function collectAllPickups(world: World): void {
  const p = getPlayer(world);
  if (!p || !p.alive) return;
  for (const pk of entitiesOfKind<Pickup>(world, 'pickup')) collectPickup(world, p, pk);
}
